import StructureComponent from './StructureComponent'
import Context from './AppContext'
import React, { Fragment } from 'react'
import { AppProps, AppContext } from '../types'
import { extendStoreWithSubscribe } from './extendStoreWithSubscribe'
import { IPropsStore, IStructureAPI, IRenderedStore } from '@wix/thunderbolt-symbols'
import ComponentsStylesOverrides from './ComponentsStylesOverrides'

function App({
	structure,
	props,
	renderedStore,
	compEventsRegistrar,
	comps,
	compControllers,
	onComponentRender,
	logger,
	translate,
	batchingStrategy,
	createCompControllerArgs,
}: AppProps) {
	const contextValue: AppContext = {
		structure: extendStoreWithSubscribe<IStructureAPI>(structure, batchingStrategy),
		props: extendStoreWithSubscribe<IPropsStore>(props, batchingStrategy),
		renderedStore: extendStoreWithSubscribe<IRenderedStore>(renderedStore, batchingStrategy),
		compEventsRegistrar,
		logger,
		comps,
		compControllers,
		translate,
		onComponentRender,
		createCompControllerArgs,
	}

	return (
		<Fragment>
			<Context.Provider value={contextValue}>
				<ComponentsStylesOverrides />
				<StructureComponent key="main_MF" id="main_MF" />
			</Context.Provider>
		</Fragment>
	)
}

export default App
